import {
  SEND_MESSAGE_REQUEST,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAILURE,
  GET_ALL_SESSIONS_REQUEST,
  GET_ALL_SESSIONS_SUCCESS,
  GET_ALL_SESSIONS_FAILURE,
  GET_SESSION_HISTORY_REQUEST,
  GET_SESSION_HISTORY_SUCCESS,
  GET_SESSION_HISTORY_FAILURE,
} from "./aiChatBotTypes";

const initialSendMessageState = {
  loading: false,
  messageResponse: {},
  error: "",
};

const sendMessageReducer = (state = initialSendMessageState, action) => {
  switch (action.type) {
    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SEND_MESSAGE_SUCCESS:
      return {
        loading: false,
        messageResponse: action.payload,
        error: "",
      };
    case SEND_MESSAGE_FAILURE:
      return {
        loading: false,
        messageResponse: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialSessionsState = {
  loading: false,
  sessionsList: [],
  error: "",
};

const getAllSessionsReducer = (state = initialSessionsState, action) => {
  switch (action.type) {
    case GET_ALL_SESSIONS_REQUEST:
      return { ...state, loading: true };
    case GET_ALL_SESSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionsList: action.payload,
        error: "",
      };
    case GET_ALL_SESSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        sessionsList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialHistoryState = {
  loading: false,
  activeSessionData: null,
  error: "",
};

const getSessionHistoryReducer = (state = initialHistoryState, action) => {
  switch (action.type) {
    case GET_SESSION_HISTORY_REQUEST:
      return { ...state, loading: true, activeSessionData: null, error: "" };
    case GET_SESSION_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        activeSessionData: action.payload,
        error: "",
      };
    case GET_SESSION_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        activeSessionData: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { sendMessageReducer, getAllSessionsReducer, getSessionHistoryReducer };
